<nav mat-tab-nav-bar mat-stretch-tabs="false" mat-align-tabs="start" [tabPanel]="tabPanel">
  @for (tab of tabs(); track tab) {
    @let unread = unreadCount(tab.link);
    <a
      [disabled]="!connectionService.isOnline()"
      mat-tab-link
      [routerLink]="tab.link"
      [queryParams]="tab.queryParams | parseQueryParams"
      routerLinkActive
      #rla="routerLinkActive"
      [active]="mainTabsService.isTabActive(tab)"
      [class.has-unread]="unread > 0">
      <div class="right-clickable" (contextmenu)="onContextMenu($event, $index)">
        <!--
          Unread-message badge, overlaid in the tab's top-right corner. It is absolutely
          positioned (see `.unread-badge` in the SCSS) so it sits over the corner rather
          than taking part in the tab's flex row. Because it no longer shares a slot with
          the close control, the two can coexist — badge in the corner, ✕ inline.
        -->
        @if (unread > 0) {
          <span class="unread-badge">{{ badgeLabel(unread) }}</span>
        }
        <div class="tab-content">
          <span class="tab-label">{{ tab.displayName }}</span>
          <!-- Close (✕) control, kept in a fixed-width slot; shown only when more than one tab is open. -->
          @if ($count > 1) {
            <span class="tab-end-slot">
              <mat-icon
                class="close-icon"
                inline
                (click)="$event.stopPropagation(); $event.preventDefault(); mainTabsService.closeTab($index)">
                cancel
              </mat-icon>
            </span>
          }
        </div>
        <div
          class="invisible-context-menu"
          [style.left.px]="menuPosition.x"
          [style.top.px]="menuPosition.y"
          [matMenuTriggerFor]="contextMenu"
          #menuTrigger="matMenuTrigger"></div>
      </div>
    </a>
  }
</nav>
<mat-tab-nav-panel #tabPanel>
  @if (routerResolveStatus.IsLoading) {
    <mat-progress-bar mode="indeterminate" class="warn" />
  } @else {
    <router-outlet />
  }
</mat-tab-nav-panel>

<mat-menu #contextMenu="matMenu">
  <button type="button" mat-menu-item (click)="mainTabsService.closeAllToRightOfTab(indexOfTab)">
    <span>Close all tabs to right</span>
  </button>
  <button type="button" mat-menu-item (click)="mainTabsService.closeAllButThisTab(indexOfTab)">
    <span>Close all but current tab</span>
  </button>
</mat-menu>
